import axios from '@/axios/globalaxios'

export const findClassByUserId = data =>{
    return axios({
        url: "/tradelab/course/findClassByUserId",
        method: 'post',
        data:data
    })
}
export const findGroupByUserIdAndClassId = data =>{
    return axios({
        url: "/tradelab/courseGroup/findGroupByUserIdAndClassId",
        method: 'post',
        data:data
    })
}

